import { AfterViewInit, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { TratamientosApiService } from 'src/app/service/api/tratamientos-api.service';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { environment } from 'src/environments/environment';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { jsPDF } from 'jspdf';
import { TratamientosControlModel } from 'src/app/models/tratamientos/tratamientos-control.model';
import { ReactiveFormBuilderComponent } from '@fitogest/reactive-form-builder';
import {
    ReactiveFormChangedField,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { TratamientosControlFormDefinition } from './form-definition';
import { TratamientosControlMagramaDataSource } from './tratamientos-control-magrama.datasource';
import { TratamientosControlRecipeBuilder } from './tratamientos-control-recipe.builder';
import { TratamientosControlEditStateHydrator } from './tratamientos-control-edit-state.hydrator';

moment.locale('es');

@Component({
    selector: 'app-control-tratamientos-form',
    standalone: false,
    templateUrl: './control-form.component.html',
    styleUrls: ['./control-form.component.scss']
})
export class TratamientosControlFormComponent extends BaseForm<TratamientosControlModel> implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
        requestButton = new RequestButtonComponent<TratamientosControlModel>();

    @ViewChild(ReactiveFormBuilderComponent)
        formBuilder!: ReactiveFormBuilderComponent<TratamientosControlModel>;

    public appName = environment.appName;


    public showEliminarControl = false;
    public formType = this.getType();

    public override pathToGoBack = 'tratamientos-control';
    public override model: TratamientosControlModel = { estado: 'Planificado' };

    public form!: TratamientosControlFormDefinition;

    public receta: TratamientosControlModel = {};
    public showReceta = false;
    public isGeneratingCanvas = false;


    public get activeRequest() {
        return this.formType === FormType.EDITION
            ? this.tratamientosApi.tratamientosControl.PUT
            : this.tratamientosApi.tratamientosControl.POST;
    }

    private readonly magramaDataSource: TratamientosControlMagramaDataSource;

    private editStateRaw: Record<string, unknown> | null = null;
    private editStateHydrationPromise: Promise<void> | null = null;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        public productosApi: ProductosApiService,
        public trabajadoresApi: TrabajadoresApiService,
        public tratamientosApi: TratamientosApiService,
        public tareasApi: TareasApiService,
        public formApi: FormCommonApiService,
        public override dashboard: DashboardService
    ) {
        super(
            route,
            router,
            dashboard,
            tratamientosApi.tratamientosControl.PUT,
            tratamientosApi.tratamientosControl.POST,
            'tratamientos-control',
            'Editar Control de Tratamientos',
            'Crear Control de Tratamientos'
        );

        this.form = new TratamientosControlFormDefinition(this.getType());
        this.form.setFincasDataSource(this.fincasApi.fincasGET);
        this.form.setParcelasDataSource(this.fincasApi.parcelasGET);
        this.form.setMaquinariaDataSource(this.trabajadoresApi.maquinariaGET);
        this.form.setProductosDataSource(this.productosApi.productos.GET);
        this.magramaDataSource = new TratamientosControlMagramaDataSource(formApi);
        this.form.setMagramaDataLoader((context) => this.magramaDataSource.loadSlot(context));

        this.route.queryParams.subscribe(params => {
            if (params['finca']) {
                this.model.id_finca = +params['finca'];
            }
            if (params['fecha']) {
                this.model.fecha = moment(params['fecha'], 'DD-MM-YYYY').format('DD/MM/YYYY');
            }
        });
    }


    ngOnInit(): void {
        this.formType = this.getType();
        this.restoreSavedMaquinariaSelection();

        if (this.getType() === FormType.EDITION) {
            this.tratamientosApi.tratamientosControl.GET.response(() => {
                this.editStateRaw = this.getEditStateRawValue();
                this.tryApplyEditState();
            });
        }

        this.softInit(this.getType());
    }

    public ngAfterViewInit(): void {
        this.tryApplyEditState();
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<TratamientosControlModel>): void {
        this.applyFormChange(event.value, event.changedField);
    }

    public formChanges(
        formModel: ReactiveFormValue<TratamientosControlModel>,
        tag: ReactiveFormChangedField<TratamientosControlModel>,
    ): void {
        this.applyFormChange(formModel, tag);
    }

    public showEliminar(): void {
        this.showEliminarControl = false;
        this.tratamientosApi.tratamientosControl.DELETE.toPromise(this.model)
            .then(() => { window.location.reload(); return; })
            .catch(e => console.log('catch DELETE:', e));
    }

    public generarReceta(): void {
        this.receta = TratamientosControlRecipeBuilder.build({
            model: this.model,
            readControlValue: (fieldName) => this.formBuilder?.model?.get(fieldName)?.value,
            resolveFincaLabel: (value) => this.resolveFincaLabel(value),
            resolveProductRawValue: (value) => this.form.resolveProductRawValue(value),
        });

        this.receta.fecha_dmy = moment(this.model.fecha).format('DD/MM/YYYY');
        this.receta.fecha = moment(this.receta.fecha).format('LL');
        this.showReceta = true;

        const elements = document.getElementsByClassName('p-dialog-content');
        setTimeout(() => { if (elements[0]) { elements[0].scrollTop = 0; } }, 100);
    }

    public imprimirReceta(): void {
        this.isGeneratingCanvas = true;
        html2canvas(
            document.getElementById('html2canvasDiv') ?? new HTMLElement,
            { scale: 2, logging: false }
        ).then(canvas => {
            this.isGeneratingCanvas = false;
            const pdf = new jsPDF('l', 'mm', 'a4');
            const data = canvas.toDataURL('image/png');
            const w = 290;
            pdf.addImage(data, 'png', 0, 0, w, (canvas.height / (canvas.width / w)), 'alias', 'FAST');
            pdf.save((this.receta.plagas || '.').replace('.', ''));
            return;
        }).catch(e => console.log('catch html2canvas:', e));
    }

    public get recetaParcelasLabel(): string {
        return this.getCurrentParcelIds()
            .map((parcelId) => this.resolveParcelaLabel(parcelId))
            .filter((label) => label.length > 0)
            .join(', ');
    }

    override ngOnDestroy(): void {
        this.tratamientosApi.tratamientosControl.GET.unsuscribe();
        this.tratamientosApi.tratamientosControl.POST.unsuscribe();
        this.tratamientosApi.tratamientosControl.PUT.unsuscribe();
        this.tratamientosApi.tratamientosControl.DELETE.unsuscribe();
    }

    private applyFormChange(
        formModel: ReactiveFormValue<TratamientosControlModel>,
        tag: ReactiveFormChangedField<TratamientosControlModel>,
    ): void {
        const changedField = String(tag);

        this.model = formModel as TratamientosControlModel;

        if (changedField === 'id_maquinaria') {
            localStorage.setItem(
                this.appName + '_CT_MAQUINARIA_SELECTED',
                this.model.id_maquinaria ?? ''
            );
        }

        if (changedField === 'estado') {
            this.form.updateRequiredFieldsForEstado(this.model.estado);
        }
    }

    private getCurrentParcelIds(): string[] {
        const idsRaw = this.receta?.ids_parcelas
            ?? this.model.ids_parcelas
            ?? this.editStateRaw?.['ids_parcelas'];

        if (Array.isArray(idsRaw)) {
            return idsRaw
                .map((item) => this.resolveParcelId(item))
                .filter((id) => id !== '');
        }

        if (!idsRaw) {
            return [];
        }

        return String(idsRaw)
            .split(/[;,]/)
            .map((id) => id.trim())
            .filter((id) => id !== '');
    }

    private resolveParcelId(value: unknown): string {
        if (value !== null && typeof value === 'object') {
            const record = value as Record<string, unknown>;
            const id = record['id'] ?? record['value'];

            return id === null || id === undefined ? '' : String(id).trim();
        }

        return value === null || value === undefined ? '' : String(value).trim();
    }

    private resolveParcelaLabel(parcelId: string): string {
        const label = this.formBuilder?.resolveDropdownLabel('ids_parcelas', parcelId).trim() ?? '';

        if (label !== '') {
            return label;
        }

        const raw = this.formBuilder?.resolveDropdownRawValue<Record<string, unknown>>('ids_parcelas', parcelId);

        if (raw && typeof raw['nombre'] === 'string') {
            return raw['nombre'];
        }

        return parcelId;
    }

    private getEditStateRawValue(): Record<string, unknown> {
        const getValue = this.tratamientosApi.tratamientosControl.GET.value as Record<string, unknown>[] | undefined;

        return getValue?.[0] ?? {};
    }

    private restoreSavedMaquinariaSelection(): void {
        if (this.formType !== FormType.CREATION) {
            return;
        }

        const saved = localStorage.getItem(this.appName + '_CT_MAQUINARIA_SELECTED');

        if (saved) {
            this.model.id_maquinaria = saved;
        }
    }


    private resolveFincaLabel(value: unknown): string | null {
        const label = this.formBuilder?.resolveDropdownLabel('id_finca', value).trim() ?? '';

        return label !== '' ? label : null;
    }

    private tryApplyEditState(): void {
        if (this.getType() !== FormType.EDITION
            || !this.formBuilder
            || this.editStateRaw === null
            || this.editStateHydrationPromise !== null) {
            return;
        }

        this.editStateHydrationPromise = this.applyEditStateWhenReady(this.editStateRaw);
    }

    private async applyEditStateWhenReady(raw: Record<string, unknown>): Promise<void> {
        const isReady = await this.formBuilder.whenFieldReady('id_finca');

        if (!isReady) {
            this.editStateHydrationPromise = null;
            return;
        }

        TratamientosControlEditStateHydrator.apply({
            formType: this.getType(),
            raw,
            model: this.model,
            formBuilder: this.formBuilder,
        });
    }
}
